import {select} from 'redux-saga/effects';
import {VIEWER_END_PAGE_COUNT} from '../constant/talkViewerConstant';
import {TalkViewerState} from '../state/TalkViewerState.interface';
import {selectCanShowViewerEnd, selectTalkViewerState} from './selector';

export function* getTalkViewerEndPageCount() {
  const talkViewerInfoState: TalkViewerState = yield select(
    selectTalkViewerState
  );
  const canShowViewerEnd: boolean = yield select(state =>
    talkViewerInfoState.currentViewerInfoData
      ? selectCanShowViewerEnd(state, talkViewerInfoState.currentViewerInfoData)
      : false
  );

  return canShowViewerEnd ? VIEWER_END_PAGE_COUNT : 0;
}
